import { useCentralStore } from "src/stores/central";
import { computed } from "vue";
import { useRoute } from "vue-router";
/**
 * Wrapper for string methods in 'src/plugins/string/string'
 * @returns wrapped string methods for use in setup
 */
const AppCurrencyMethod = (country = computed(() => "")) => {
    const vueRoute = useRoute();
    const centralStore = useCentralStore();
    const countryCurrency = computed(() => {
        const storeCountryMap = centralStore.countryMap;
        const routeCountry = vueRoute.params.country;
        const countryToUse = (country?.value || routeCountry).toUpperCase();
        const countryMapDetails = storeCountryMap[countryToUse] || storeCountryMap[routeCountry] || storeCountryMap["SG"];
        return {
            "country_currency": countryMapDetails?.country_currency || "",
            "country_currency_symbol": countryMapDetails?.country_currency_symbol || "",
        };
    });
    return {
        countryCurrency
    };
};
const AppCurrencySymbolMethod = (currency = computed(() => "")) => {
    const centralStore = useCentralStore();
    function getCountryCurrencySymbol(currency) {
        const storeCountryMap = centralStore.countryMap;
        for (const key in storeCountryMap) {
            const value = storeCountryMap[key];
            if (value.country_currency === currency) {
                return value.country_currency_symbol;
            }
        }
        return "$";
    }
    const countryCurrencySymbolFromCurrency = computed(() => {
        return getCountryCurrencySymbol(currency.value);
    });
    return {
        getCountryCurrencySymbol,
        countryCurrencySymbolFromCurrency
    };
};
export { AppCurrencyMethod, AppCurrencySymbolMethod };
